import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { identifiesApi } from "@/lib/api";
import type { IdentifyCreate, IdentifyUpdate } from "@/types";

export function useIdentifies() {
  return useQuery({
    queryKey: ["identifies"],
    queryFn: () => identifiesApi.list(),
  });
}

export function useIdentify(id: string) {
  return useQuery({
    queryKey: ["identifies", id],
    queryFn: () => identifiesApi.get(id),
    enabled: !!id,
  });
}

export function useCreateIdentify() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: IdentifyCreate) => identifiesApi.create(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["identifies"] }),
  });
}

export function useUpdateIdentify() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: IdentifyUpdate }) =>
      identifiesApi.update(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["identifies"] }),
  });
}

export function useDeleteIdentify() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => identifiesApi.delete(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["identifies"] }),
  });
}
